
<style scoped lang="scss">
.address-wrapper /deep/ {
    background: #ffffff;
    .address-wrapper .van-address-list {
        border: 0;
        background: #ffffff;
    }
    .van-address-item {
        padding: 0.533333rem 0.373333rem;
        box-shadow: 0px 4px 4px rgba(174, 174, 174, 0.25);
        border-radius: 0.266667rem;
        margin-top: 0.533333rem;
        border: 1px solid rgba(174, 174, 174, 0.25);
    }
    .van-address-item__address {
        padding: 0 0.133333rem;
        font-weight: bold;
        line-height: 0.533333rem;
        font-size: 14px;
        color: #666666;
        word-break: break-all;
    }
    .van-address-item__name {
        font-size: 16px;
        font-weight: 400;
        color: $grey5;
        line-height: 0.586667rem;
        margin-bottom: 0.373333rem;
    }
    .van-address-item .van-radio__icon--checked .van-icon {
        border-color: $orange !important;
        background-color: $orange !important;
    }
    .van-address-list__add {
        height: 1.226667rem;
        line-height: 1.306667rem;
        background: linear-gradient(
            91deg,
            rgba(248, 200, 64, 1) 0%,
            rgba(245, 149, 38, 1) 100%
        );
        border: 0;
    }
    .van-address-item__edit {
        top: 50%;
        right: 0;
        font-size: 16px;
        -webkit-transform: translate(0, -50%);
        transform: translate(0, -50%);
        width: 64px;
        height: 120px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: url("https://oss.tuoxingwang.com/vaporetto-assets/common/address-edit.png")
            50% 50% no-repeat;
        background-size: 30% 20%;
        &:before {
            display: none;
        }
    }
    .no-content {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-top: 22%;
        img {
            width: 6.613333rem;
            height: 5.906667rem;
        }
        p {
            color: #444444;
            font-size: 0.373333rem;
            text-align: center;
            font-weight: bold;
        }
    }
}
</style>

<template>
    <div class="address-wrapper">
        <van-address-list
            v-model="defaultAddressId"
            :list="list"
            @add="onAdd"
            @edit="onEdit"
            @select="onSelect"
        />
        <div class="no-content" v-if="list.length == 0">
            <img :src="noaddressSrc" alt="no-address" />
            <p>还没有收货地址哦~</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "UserAddress",
    components: {},
    props: {
        // layouts: String,
        // layoutType: String,
    },
    data() {
        return {
            noAddress: true,
            defaultAddressId: undefined,
            list: [],
            noaddressSrc: "",
        };
    },
    computed: {},
    watch: {
        list(value) {
            if (value.length === 0) return undefined;
            let defaultAddress = value.find((e) => e.isDefault == "1");
            this.defaultAddressId = defaultAddress
                ? defaultAddress.id
                : undefined;
        },
    },
    created() {
        this.getAddress();
    },
    mounted() {
        this.noaddressSrc = API.ossUrl + "common/empty_icons/noaddress.png";
    },
    destroyed() {},
    methods: {
        onAdd() {
            this.$router.push({ name: "userAddressEdit", params: { type: 0 } });
        },

        onEdit(item, index) {
            item.isDefault = item.id === this.defaultAddressId;
            sessionStorage.currentAddress = JSON.stringify(item);
            this.$router.push({ name: "userAddressEdit", params: { type: 1 } });
        },
        onSelect(item, index) {
            let body = {
                real_name: item.name,
                phone: item.tel,
                detail: item.addressDetail,
                province: item.province,
                city: item.city,
                county: item.county,
                area_code: item.areaCode,
                is_default: "1",
            };
            const URL = `${window.API.user.updateAddress}/${item.id}?token=${sessionStorage.token}`;
            this.$axios
                .post(URL, body)
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.$toast("设置默认地址成功！");
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch((err) => console.log(err));
        },
        getAddress() {
            this.$axios
                .get(`${window.API.user.address}?token=${sessionStorage.token}`)
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.list =
                            data.data.length > 0
                                ? data.data.map((e) => {
                                      return {
                                          id: e.id,
                                          name: e.real_name,
                                          tel: e.phone,
                                          address: `${e.province}${
                                              e.city || ""
                                          }${e.county || ""} ${e.detail || ""}`,
                                          addressDetail: e.detail,
                                          province: e.province,
                                          city: e.city,
                                          county: e.county,
                                          areaCode: e.area_code || 0,
                                          isDefault: e.is_default == 1,
                                      };
                                  })
                                : [];
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch((err) => console.log(err));
        },
    },
};
</script>
